import React from 'react';
import { ThemeProvider, createTheme, CssBaseline } from '@mui/material';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: '#42a040' },
    secondary: { main: '#2e7d2e' },
    background: {
      default: '#f4fbf6',
    },
  },
  shape: {
    borderRadius: 12,
  },
  typography: {
    fontFamily: 'Inter, system-ui, -apple-system, sans-serif',
    fontWeightBold: 700,
  },
});

type ThemeProviderProps = {
  children: React.ReactNode;
};

export const AppThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => (
  <ThemeProvider theme={theme}>
    <CssBaseline />
    {children}
  </ThemeProvider>
);

